export default "__VITE_ASSET__CObxjylF__"